var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterTg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1078_4061)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4692 0.828125C8.58549 0.828125 6.74417 1.38669 5.17798 2.43317C3.6118 3.47967 2.39111 4.96708 1.67027 6.70733C0.949441 8.44758 0.760837 10.3625 1.12831 12.2099C1.4958 14.0574 2.40284 15.7543 3.73478 17.0863C5.0667 18.4182 6.76368 19.3253 8.61112 19.6928C10.4586 20.0602 12.3734 19.8717 14.1137 19.1508C15.854 18.4299 17.3414 17.2093 18.3879 15.6431C19.4344 14.0769 19.993 12.2356 19.993 10.3519C19.9931 9.10122 19.7468 7.86273 19.2682 6.70721C18.7896 5.55168 18.0881 4.50174 17.2037 3.61735C16.3193 2.73296 15.2693 2.03145 14.1138 1.55287C12.9583 1.07429 11.7198 0.828021 10.4692 0.828125ZM13.4973 15.2591C13.4615 15.3479 13.4073 15.4281 13.3381 15.4944C13.269 15.5606 13.1864 15.6113 13.096 15.643C13.0056 15.6747 12.9095 15.6867 12.8142 15.6782C12.7188 15.6697 12.6263 15.641 12.543 15.5938L9.95754 13.5849L8.2982 15.1157C8.25969 15.1442 8.21465 15.1625 8.16722 15.169C8.11979 15.1755 8.07149 15.1699 8.02677 15.1528L8.34486 12.3067L8.35504 12.3148L8.36155 12.2586C8.36155 12.2586 13.0139 8.02284 13.2034 7.84237C13.3953 7.66237 13.332 7.62333 13.332 7.62333C13.343 7.40377 12.9877 7.62333 12.9877 7.62333L6.82342 11.5891L4.25628 10.7148C4.25628 10.7148 3.862 10.5734 3.82485 10.2624C3.78581 9.95384 4.26913 9.78622 4.26913 9.78622L14.4758 5.73145C14.4758 5.73145 15.3149 5.35762 15.3149 5.9767L13.4973 15.2591Z",
    fill: "white",
    fillOpacity: 0.75
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1078_4061"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 19.0476,
    fill: "white",
    transform: "translate(0 0.828125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterTg);
export default __webpack_public_path__ + "static/media/footer_tg.239756a64590658b2f36586ea55100d5.svg";
export { ForwardRef as ReactComponent };